import React from "react";
import { Typography, useTheme } from "@mui/material";

export default function SortlyBooksLogo() {
  const theme = useTheme();

  return (
    <Typography
      variant="h6"
      sx={{
        fontWeight: 700,
        fontSize: "1.25rem",
        color: theme.palette.text.primary,
        fontFamily: "Inter, Poppins, sans-serif",
        letterSpacing: "-0.5px",
      }}
    >
      SortlyBooks
    </Typography>
  );
}
